// @ts-nocheck

export type RoomGetWithOwnerMemosFiles = typeof RoomGetWithOwnerMemosFiles[keyof typeof RoomGetWithOwnerMemosFiles];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoomGetWithOwnerMemosFiles = {
  true: 'true',
  false: 'false',
} as const;
